import { TeacherLocationSelector } from "@/pages/profiel/TeacherLocationSelector"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/locaties/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <TeacherLocationSelector />
}
